import { HttpClient } from './client'
import { TokenManager } from '../auth/tokenManager'

interface ScorePendingResponse {
  nodeIds: string[]
}

/**
 * Fetch the node IDs that currently have scoring in progress for this mindmap.
 *
 * The mindmap mount calls this alongside the score fetch so the loading badge
 * is seeded from persistent state — covering the case where the user
 * triggered scoring from another page (e.g. survey close) and only just
 * navigated to the mindmap, so the realtime `score_started` broadcast was
 * never delivered to this client.
 */
export async function fetchScorePending(mindmapId: string): Promise<string[] | null> {
  const headers = await TokenManager.getAuthHeaders()
  const result = await HttpClient.get<ScorePendingResponse>(
    `/mindmaps/${mindmapId}/score-pending`,
    headers
  )
  if (result.error) return null
  return result.data?.nodeIds ?? []
}
